import { TypedEvent } from "../../typed_event"
import { JsEnv } from '../../../core/models/js_env';
import HistoryUtil from '../../util/history_util';
import DomUtil from "../../util/dom_util";
import { ItemRefineSearch } from "../../models/item_refine_search/item_refine_search"
import { ItemRefineSearchRepository } from "../../repositories/item_refine_search/item_refine_search_repository"
import { ItemRefineSearchContainer } from "../../views/pc/item_refine_search/item_refine_search_container"
import { ItemRefineSearchJsEnv, QueryParameter } from "../../models/item_refine_search/item_refine_search_js_env";
import { SubstituteItemAreaAnalytics } from '../analytics/substitute_item_area_analytics';
import { AsyncSearchKeywordAnalytics } from '../analytics/async_search_keyword_analytics';
import { AsyncSearchMiddleSmallCategoryAnalytics } from '../analytics/async_search_middle_small_category_analytics';
import { AnalyticsMiddleSmallSearch } from '../../../core/models/analytics/async_search_middle_small_category_data';
import { AdobeAnalyticsData } from '../../models/analytics/adobe_analytics_data';
import { AsyncSearchKeywordPagingAnalytics } from "../analytics/async_search_keyword_paging_analytics";
import { AsyncSearchMAndSCategoryPagingAnalytics } from "../analytics/async_search_m_and_s_category_paging_analytics";
import { AdobeAnalyticsMOrSCategoryPagingData } from "../../models/analytics/async_m_and_s_category_paging_data";

export class ItemRefineSearchAction {
  static readonly UPDATE_EVENT = new TypedEvent<ItemRefineSearch>();
  static readonly SEND_IN_SITE_SEARCH_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly SEND_MIDDLE_SMALL_CATEGORY_SEARCH_EVENT = new TypedEvent<AnalyticsMiddleSmallSearch>();
  static readonly SEND_IN_SITE_SEARCH_PAGING_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly SEND_M_AND_S_CATEGORY_PAGING_EVENT = new TypedEvent<AdobeAnalyticsMOrSCategoryPagingData>();
  static readonly SEND_MIDDLE_CATEGORY_SEARCH_EVENT = new TypedEvent<AdobeAnalyticsData>();
  private static state: ItemRefineSearch;
  private static itemRefineSearchRepository: ItemRefineSearchRepository;
  static async init(env: JsEnv) {
    this.itemRefineSearchRepository = new ItemRefineSearchRepository();
    this.state = new ItemRefineSearch(env.PAGE);
    new SubstituteItemAreaAnalytics(); // NOSONAR
    /// キーワード検索画面
    if (this.state.isKeywordSearch() || this.state.isLKeywordSearch()) {
      new AsyncSearchKeywordAnalytics(); // NOSONAR
      new AsyncSearchKeywordPagingAnalytics(); // NOSONAR
    }
    /// 中小カテゴリー検索画面
    if (this.state.isCategoryMSearch() || this.state.isCategorySSearch()) {
      new AsyncSearchMiddleSmallCategoryAnalytics(); // NOSONAR
      new AsyncSearchMAndSCategoryPagingAnalytics(); // NOSONAR
    }
    new ItemRefineSearchContainer(this.state); // NOSONAR
    // メソッドをwindowに外だしするとthisがwindowに指すため、ここでthisをクラスとバインドする必要がある
    env.FUNCTIONS['refreshItemRefineSearchAreas'] = this.refreshItemRefineSearchAreas.bind(this);
    // 戻るボタンと進むボタンをハンドル
    window.onpopstate = this.popStateHandler.bind(this);
  }

  // 絞り込みのチェックボックスからこのメソッドを呼び出す(windowに公開)
  private static async refreshItemRefineSearchAreas(newParameters: QueryParameter[], popStateEvent?: PopStateEvent) {
    this.state.showLoadingSpinner();

    const isHistoryBackOrForward = popStateEvent;
    let clickTarget: null | HTMLElement = null;
    if (isHistoryBackOrForward) {
      // popstateイベントの場合はevent内のモデルで現在のモデルを更新
      this.state.updateSearchParameterFromPopstateEvent(popStateEvent?.state?.refineSearchParameter);
    } else {
      // 最初のページにいた場合、stateにpopstateイベントで必要な情報を設定する
      if (history.state === null && HistoryUtil.isBrowserSupportsHistory()) {
        HistoryUtil.replaceNewUrlToHistory(window.location.href, {refineSearchParameter: this.state.getRefineSearchParameter()});
      }
      // 画面のチェックボックスを押下した場合はonclickイベントの引数からモデルを更新
      this.state.updateSearchParameter(newParameters);
      const e = window.event ? window.event : null;
      if (e != null) {
        clickTarget = (e.currentTarget as HTMLElement)?.parentElement ?? null;
      }
    }
    const urlForNewDoc = this.state.createSearchUrl();

    if (!HistoryUtil.isBrowserSupportsHistory()) {
      window.location.href = urlForNewDoc;
      return;
    }

    // キーワード検索画面でパラメーターがない場合は、キーワード検索画面にリダイレクト。
    // キーワード検索の処理にてパラメータがない場合は、警告メッセージが表示された詳細検索画面に遷移
    if (this.state.isKeywordSearch() && this.state.isNoQueryCheck()) {
      window.location.href = '/ksearch/';
    }

    let htmlForRender: Document;
    try {
      htmlForRender = await this.itemRefineSearchRepository.getItemRefineSearchHtml(urlForNewDoc);
    } catch {
      alert('通信に失敗しました。一時的に利用できない可能性があります。');
      this.state.hideLoadingSpinner();
      return;
    }

    if (htmlForRender.URL.match("/as/medical/medicalConfirm") != null) {
      window.location.href = htmlForRender.URL;
    }

    const newJsEnv = DomUtil.getJsEnv<ItemRefineSearchJsEnv>(htmlForRender);
    if (newJsEnv) {
      // ページングされると、/m/大大カテコード-大カテコード-中カテコード-ページ番号/のようにパスにページ番号が差し込まれる。
      // この形式のURLをpushStateするため、selfLinkを新Docのもので更新する。
      this.state.updateSelfLink(newJsEnv.selfLink)
    }

    // ページングされたときに/m/大大カテコード-大カテコード-中カテコード-ページ番号/?page=ページ番号とならないように
    // パラメータのリストからpageを削除する
    if (this.state.isCategoryMSearch() || this.state.isCategorySSearch()) {
      this.state.removePageParameter();
    }

    const urlForPushingHistory = this.state.createSearchUrl();
    if (!isHistoryBackOrForward) {
      HistoryUtil.pushNewUrlToHistory(urlForPushingHistory, {refineSearchParameter: this.state.getRefineSearchParameter()});
    }

    this.state.updateHtmlForRender(htmlForRender);
    this.UPDATE_EVENT.trigger(ItemRefineSearchAction.state);

    if (!isHistoryBackOrForward) {
      if (clickTarget != null) {
        this.setAnalytics(this.state, clickTarget as HTMLElement, newParameters);
      }
    }
    (window as any).Modal.scrollLock.enableBodyScroll();
    // チェックボックスにチェックをつけるにはtrueを返却す必要がある
    return true;
  }

  private static popStateHandler(event: PopStateEvent) {
    this.refreshItemRefineSearchAreas([], event);
  }

  private static setAnalytics(
    model: ItemRefineSearch,
    target: HTMLElement,
    newParameters: QueryParameter[]
  ) {
    const isPaging = newParameters.some(({ key }) => key === 'page');

    /// 非同期ページング
    if (isPaging) {
      /// キーワード検索画面
      if (model.isKeywordSearch() || model.isLKeywordSearch()) {
        return this.SEND_IN_SITE_SEARCH_PAGING_EVENT.trigger({
          linkName: 'pagingPjax',
          target: target
        });
      }
      /// 中カテゴリー検索画面
      if (model.isCategoryMSearch()) {
        return this.SEND_M_AND_S_CATEGORY_PAGING_EVENT.trigger({
          linkName: 'pagingPjax',
          target: target,
          friendlyPageName: '中カテゴリー_ページング_非同期'
        });
      }
      /// 小カテゴリー検索画面
      if (model.isCategorySSearch()) {
        return this.SEND_M_AND_S_CATEGORY_PAGING_EVENT.trigger({
          linkName: 'pagingPjax',
          target: target,
          friendlyPageName: '小カテゴリー_ページング_非同期'
        });
      }

      return;
    }

    /// キーワード検索画面
    if ((model.isKeywordSearch() || model.isLKeywordSearch()) && !isPaging) {
      return this.SEND_IN_SITE_SEARCH_EVENT.trigger({
        target: target,
        linkName: 'kwSearchPjax'
      });
    }

    /// 中小カテゴリー検索画面
    if ((model.isCategoryMSearch() || model.isCategorySSearch()) && !isPaging) {
      return this.SEND_MIDDLE_SMALL_CATEGORY_SEARCH_EVENT.trigger({
        linkName: 'ctgSearchPjax',
        target: target,
        isCategorySSearch: model.isCategorySSearch()
      });
    }
  }
}
